// LEGAL STATUS: To be legally validated before commercial production (EN translation of fr/LegalNoticePage.js).
import { Page, H1, H2, Lead, P, UL, LegalValue, Notice, PublisherCountry } from "../../public/primitives";
import { legal } from "../../../config/legal";

export const LegalNoticePage = () => (
  <Page testid="legal-notice-page">
    <H1>Legal notice</H1>
    <Lead>Information about the publisher and the hosting of the SecurePass service.</Lead>

    <H2 id="editeur">Service publisher</H2>
    <P>
      The <b>{legal.serviceName}</b> service is published and operated by <b>{legal.publisherName}</b>,
      in <PublisherCountry />.
    </P>
    <UL>
      <li>Legal form: <LegalValue value={legal.legalForm} /></li>
      <li>Share capital: <LegalValue value={legal.shareCapital} /></li>
      <li>RIDET: <LegalValue value={legal.ridet} /></li>
      <li>RCS: <LegalValue value={legal.rcs} /></li>
      <li>Registered office address: <LegalValue value={legal.registeredOffice} /></li>
    </UL>

    <H2 id="responsable">Publication manager</H2>
    <P><LegalValue value={legal.legalRepresentative} /></P>

    <H2 id="contact">Contact</H2>
    <UL>
      <li>Email: <LegalValue value={legal.contactEmail} /></li>
      <li>Phone: <LegalValue value={legal.phone} /></li>
    </UL>

    <H2 id="hebergement">Hosting</H2>
    <UL>
      <li>Hosting provider: <LegalValue value={legal.hostingProvider} /></li>
      <li>Hosting location: <LegalValue value={legal.hostingLocation} /></li>
    </UL>

    <H2 id="propriete">Intellectual property</H2>
    <P>
      All elements making up SecurePass (brand, content, interface, code) are protected.
      Any reproduction or reuse without authorisation is prohibited.
    </P>

    <Notice testid="legal-notice-placeholder-note">
      Information marked “to be completed” must be provided before going into production;
      no value is invented.
    </Notice>
  </Page>
);

export default LegalNoticePage;
